// frontend/src/core/services/authService.ts
import { apiClient } from './apiClient';
import { AuthResponse, User } from '../types';

interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterCredentials {
  email: string;
  password: string;
  tenantName: string;
  role?: string;
}

export const authService = {
  // ✅ LOGIN: usa POST (correcto) con /api
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    // 🔥 CAMBIO: eliminar '/api' del inicio (apiClient ya lo incluye)
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    if (response.token) {
      localStorage.setItem('auth_token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
    }
    return response;
  },

  // ✅ REGISTER: usa POST (corregido: ahora usa /api)
  async register(credentials: RegisterCredentials): Promise<{ userId: string; tenantId: string; email: string }> {
    // 🔥 CAMBIO: eliminar '/api' del inicio
    return apiClient.post('/auth/register', credentials);
  },

  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
  },

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      return JSON.parse(userStr) as User;
    } catch {
      return null;
    }
  },

  getToken(): string | null {
    return localStorage.getItem('auth_token');
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};